import React, { forwardRef } from 'react';

interface InfoSVGProps {
  color?: string; // Optional color prop
}

const InfoSVG = forwardRef<SVGSVGElement, InfoSVGProps>(
  ({ color = '#FAFAFA' }, ref) => (
    <svg
      ref={ref}
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_785_532)">
        <path
          d="M7.57499 7.49984C7.77091 6.94289 8.15762 6.47326 8.66662 6.17411C9.17562 5.87497 9.77407 5.76562 10.356 5.86543C10.9379 5.96524 11.4657 6.26777 11.8459 6.71944C12.2261 7.17111 12.4342 7.74277 12.4333 8.33317C12.4333 9.99984 9.93332 10.8332 9.93332 10.8332M9.99999 14.1665H10.0083M18.3333 9.99984C18.3333 14.6022 14.6024 18.3332 9.99999 18.3332C5.39762 18.3332 1.66666 14.6022 1.66666 9.99984C1.66666 5.39746 5.39762 1.6665 9.99999 1.6665C14.6024 1.6665 18.3333 5.39746 18.3333 9.99984Z"
          stroke="#A3A3A3"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_785_532">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
);

InfoSVG.displayName = 'InfoSVG';

export default InfoSVG;
